// redux
import { useDispatch, useSelector } from "react-redux";
// entities
import { filterActions } from "@/entities/filter";
import { filterAppsDataActions } from "@/entities/filterAppsData";
import { filterAppsActions, getFilterAppsState } from "@/entities/filterApps";
import { counterActions } from "@/entities/counter";
// types

import { AppCollectionsResponse } from "@/features/auth/types/auth";

const useHandleClickAppCollection = (
  appDataAppCollections: AppCollectionsResponse | undefined,
  onSaveAppCollections: (appCollections: string) => void,
  isFetchingFilter: boolean,
  dataAppCollections: string[],
  setDataAppCollections: (appCollections: string[]) => void,
  selectedAppCollectionIds: number[],
  setSelectedAppCollectionIds: (appCollections: number[]) => void,
) => {
  const dispatch = useDispatch();
  const {
    activeModalIndexAppCollections,
    isActiveAppCollections,
    appCollections,
  } = useSelector(getFilterAppsState);

  const handleItemClick = (index: number) => {
    const isCurrentlyActive = activeModalIndexAppCollections.includes(index);
    const appCollectionName = appDataAppCollections!.results[index].name;
    const appCollection = appDataAppCollections!.results[index];

    if (isCurrentlyActive && !isFetchingFilter) {
      const updatedActiveIndexes = activeModalIndexAppCollections.filter(
        (i) => i !== index,
      );
      dispatch(
        filterAppsActions.setActiveModalIndexAppCollections(
          updatedActiveIndexes,
        ),
      );
      const updatedAppCollectionIds = selectedAppCollectionIds.filter(
        (id) => id !== appCollection.id,
      );
      setSelectedAppCollectionIds(updatedAppCollectionIds);
      dispatch(
        filterAppsActions.setAppCollections(updatedAppCollectionIds.join(",")),
      );
      setDataAppCollections(
        dataAppCollections.filter((item) => item !== appCollectionName),
      );
      dispatch(filterActions.deactivateAppCollections());
      if (updatedAppCollectionIds.length === 0) {
        dispatch(counterActions.removeFromArray("Select App Collections"));
      }
      dispatch(filterAppsActions.deactiveAppCollections());
      onSaveAppCollections(appCollectionName);

      if (appCollections !== "") {
        dispatch(filterAppsDataActions.resetFilterAppDataSorted());
        dispatch(filterAppsDataActions.resetFilterAppDataSortedAll());
        dispatch(filterAppsActions.resetPageFilterSidebar());
        dispatch(filterAppsActions.resetPageFilter());
      }
    } else if (!dataAppCollections.includes(appCollectionName)) {
      const updatedActiveIndexes = [...activeModalIndexAppCollections, index];
      dispatch(
        filterAppsActions.setActiveModalIndexAppCollections(
          updatedActiveIndexes,
        ),
      );
      const updatedAppCollectionIds = [
        ...selectedAppCollectionIds,
        appCollection.id,
      ];
      setSelectedAppCollectionIds(updatedAppCollectionIds);
      dispatch(
        filterAppsActions.setAppCollections(updatedAppCollectionIds.join(",")),
      );
      setDataAppCollections([...dataAppCollections, appCollectionName]);
      if (!isActiveAppCollections) {
        dispatch(counterActions.addToArray("Select App Collections"));
        dispatch(filterAppsActions.activeAppCollections());
      }
      dispatch(filterActions.activateAppCollections());
      onSaveAppCollections(appCollectionName);
      dispatch(filterAppsDataActions.resetFilterAppDataSorted());
      dispatch(filterAppsDataActions.resetFilterAppDataSortedAll());
      dispatch(filterAppsActions.resetPageFilterSidebar());
      dispatch(filterAppsActions.resetPageFilter());
    }
  };

  const handleReset = () => {
    if (activeModalIndexAppCollections.length > 0 && !isFetchingFilter) {
      dispatch(filterAppsActions.setActiveModalIndexAppCollections([]));
      dispatch(filterAppsDataActions.resetFilterAppDataSorted());
      dispatch(filterAppsDataActions.resetFilterAppDataSortedAll());
      dispatch(filterAppsActions.resetPageFilterSidebar());
      dispatch(filterAppsDataActions.resetFilterAppData());
      dispatch(filterAppsActions.resetPageFilter());
      dispatch(filterActions.deactivateAppCollections());
      dispatch(filterAppsActions.setAppCollections(""));
      setDataAppCollections([]);
      onSaveAppCollections("");

      if (isActiveAppCollections) {
        dispatch(counterActions.removeFromArray("Select App Collections"));
        dispatch(filterAppsActions.deactiveAppCollections());
      }
    }
  };

  return { handleItemClick, activeModalIndexAppCollections, handleReset };
};

export default useHandleClickAppCollection;
